const removeAt = (url) => url.replace("@", "");

export const formatInstagram = (url) =>
	url && `https://instagram.com/${removeAt(url)}`;
export const formatTwitter = (url) =>
	url && `https://twitter.com/${removeAt(url)}`;
export const formatTelegram = (url) => url && `https://t.me/${removeAt(url)}`;
